<div class="voucher-details d-flex flex-column justify-content-between h-100">
    <div>
        <div class="voucher-header p-4">
            <div class="d-flex justify-content-start align-items-center cursor-pointer" (click)="back()">
                <mat-icon fontIcon="arrow_back"></mat-icon>
                <span>back</span>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center my-4">
                <div class="icon">
                    <mat-icon svgIcon="cash-out"></mat-icon>
                </div>
                <h2>Cash Out via Voucher Code</h2>
            </div>
        </div>

        <div class="p-4">
            <div class="customer-details-box mb-3">
                <div class="header-bg-title">Customer Details:</div>
                <div class="body">
                    <div class="avatar">{{ customerInitials }}</div>
                    <div class="name">{{ customerFullName }}</div>
                    <div class="sub-text">{{ voucherDetails.user.email }}</div>
                </div>
            </div>

            <div class="validity-card mb-3">
                <div class="validity-top">
                    <span class="label"><mat-icon fontIcon="schedule" style="font-size: 16px; width: 16px; height: 16px"></mat-icon> Voucher validity remaining</span>
                    <span class="value" [class.urgent]="isUrgent">{{ countdown }}</span>
                </div>
                <div class="validity-progress">
                    <div class="fill" [class.urgent]="isUrgent" [style.width.%]="progressPercent"></div>
                </div>
            </div>

            <div class="summary-box">
                <div class="summary-header">
                    <div class="summary-header-main">
                        <div class="label">Cash to pay customer</div>
                        <div class="amount">
                            <span class="value">{{ finalCashAmount | number : '1.2-2' }}</span> <span class="currency">{{ voucherDetails.currency }}</span>
                        </div>
                    </div>
                    <div class="summary-header-meta">
                        <div class="meta">Ref #: {{ voucherDetails.reference_number }}</div>
                        <div class="meta">{{ voucherDetails.issued_on | date : 'd MMM y' }}</div>
                    </div>
                </div>
                <div class="summary-row">
                    <span class="row-label">Transaction amount</span>
                    <span>{{ voucherDetails.currency }} {{ voucherDetails.amount | number : '1.2-2' }}</span>
                </div>
                <div class="summary-row">
                    <span class="row-label">Service fees</span>
                    <span>{{ voucherDetails.currency }} {{ serviceFee | number : '1.2-2' }}</span>
                </div>
                <div class="summary-row highlighted">
                    <span
                        >Wallet will be credited<span class="caption"
                            >{{ voucherDetails.currency }} {{ finalCashAmount | number : '1.2-2' }} cash back + {{ voucherDetails.currency }}
                            {{ voucherDetails.commission_amount | number : '1.2-2' }} commission</span
                        ></span
                    >
                    <span>{{ voucherDetails.currency }} {{ walletCredit | number : '1.2-2' }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-bar">
        <button mat-flat-button color="primary" class="rounded-pill approve-btn" [disabled]="loading" (click)="openApprove()">Approve &amp; Pay Cash</button>
        <button mat-stroked-button color="primary" class="rounded-pill decline-btn" [disabled]="loading" (click)="openDecline()">Decline</button>
    </div>

    <div class="loading-overlay" *ngIf="loading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
</div>
